import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import ProcessingNoDataTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import processingIcon from "../../../../../assets/design-revamp-company/category-icons/processing_no_data_icon.svg";
const ProcessingNoDataContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="processing-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("PROCESSING_NO_DATA_TITLE")}
          subDescription={t("PROCESSING_NO_DATA_DESC")}
          isNormal={true}
          number={"16.1A"}
          icon={processingIcon}
        />
      </div>
      {showTable && <ProcessingNoDataTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default ProcessingNoDataContents;
